import { useMutation } from "@tanstack/react-query";
import { mutationFor, useApiConfig } from "@visioni/a3s-client-api/app";
import {
  runPatriotConnectionCheckEndpoint,
  type RunPatriotConnectionCheckResponse,
} from "../../client-messages/patriot-connection-check";

const runPatriotConnectionCheckMutation = mutationFor(runPatriotConnectionCheckEndpoint);

/**
 * Runs the Patriot connection check and resolves with its report. Support-only
 * — the API answers 403 for anyone else — and one run at a time: a second
 * while one is in progress fails with a 409. An environment with no
 * connection check answers 501.
 *
 * A mutation rather than a query: each run makes fresh requests to Patriot, so
 * it only happens when someone asks for it, and its report is never cached.
 */
export function useRunPatriotConnectionCheck() {
  const apiConfig = useApiConfig();

  const mutationConfig =
    apiConfig.tenant ?
      {
        tenantId: apiConfig.tenant.tenantId,
        apiBaseUrl: apiConfig.tenant.apiBaseUrl,
        authenticatedFetch: apiConfig.authenticatedFetch,
      }
    : { authenticatedFetch: apiConfig.authenticatedFetch };

  return useMutation<RunPatriotConnectionCheckResponse>({
    mutationFn: () => runPatriotConnectionCheckMutation(mutationConfig, {}).mutationFn({}),
  });
}
